var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2702 17.5573H13.9368V14.224H17.2702V17.5573ZM12.2702 9.22396H8.93685V12.5573H12.2702V9.22396ZM17.2702 9.22396H13.9368V12.5573H17.2702V9.22396ZM7.27018 14.224H3.93685V17.5573H7.27018V14.224ZM12.2702 14.224H8.93685V17.5573H12.2702V14.224ZM7.27018 9.22396H3.93685V12.5573H7.27018V9.22396ZM20.6035 2.55729V20.8906H0.603516V2.55729H3.10352V3.39062C3.10352 4.30979 3.85102 5.05729 4.77018 5.05729C5.68935 5.05729 6.43685 4.30979 6.43685 3.39062V2.55729H14.7702V3.39062C14.7702 4.30979 15.5177 5.05729 16.4368 5.05729C17.356 5.05729 18.1035 4.30979 18.1035 3.39062V2.55729H20.6035ZM18.9368 7.55729H2.27018V19.224H18.9368V7.55729ZM17.2702 1.72396C17.2702 1.26396 16.8977 0.890625 16.4368 0.890625C15.976 0.890625 15.6035 1.26396 15.6035 1.72396V3.39062C15.6035 3.85062 15.976 4.22396 16.4368 4.22396C16.8977 4.22396 17.2702 3.85062 17.2702 3.39062V1.72396ZM5.60352 3.39062C5.60352 3.85062 5.23102 4.22396 4.77018 4.22396C4.30935 4.22396 3.93685 3.85062 3.93685 3.39062V1.72396C3.93685 1.26396 4.30935 0.890625 4.77018 0.890625C5.23102 0.890625 5.60352 1.26396 5.60352 1.72396V3.39062Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.fed2238e9ba72f16d01072bd6b973fc3.svg";
export { ForwardRef as ReactComponent };